(function (root) {
  'use strict'

  function text(value) {
    return String(value || '').trim()
  }

  function normalise(value) {
    return text(value).toLocaleLowerCase()
  }

  function stripHtml(value) {
    return text(value).replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
  }

  function metafieldValue(article, key) {
    var metafields = Array.isArray(article && article.metafields) ? article.metafields : []
    var metafield = metafields.find(function (item) {
      return item && item.key === key && text(item.value) !== ''
    })

    return metafield ? text(metafield.value) : ''
  }

  var articleStatuses = [
    { key: 'happening-now', label: 'Happening Now' },
    { key: 'coming-soon', label: 'Coming Soon' },
    { key: 'thats-a-wrap', label: 'That’s a Wrap!' },
    { key: 'voting-open', label: 'Voting Open' },
    { key: 'winners-announced', label: 'Winners Announced' },
  ]

  function statusForTag(tag) {
    var value = normalise(tag).replace(/[‘’]/g, "'")
    return articleStatuses.find(function (status) {
      return normalise(status.label).replace(/[‘’]/g, "'") === value
    })
  }

  function getArticleStatuses(article) {
    var tags = Array.isArray(article && article.tags) ? article.tags : []
    return tags.map(statusForTag).filter(function (status, index, statuses) {
      return status && statuses.indexOf(status) === index
    })
  }

  function getArticleCategory(article) {
    var customCategory = metafieldValue(article, 'category')
    if (customCategory) return customCategory

    var tags = Array.isArray(article && article.tags) ? article.tags : []
    var taggedCategory = tags.find(function (tag) { return text(tag) !== '' && !statusForTag(tag) })
    if (taggedCategory) return text(taggedCategory)

    return text(article && article.blog && (article.blog.title || article.blog.handle))
  }

  function getArticleUrl(article) {
    var nativeUrl = text(article && article.url)
    if (nativeUrl) return nativeUrl

    var articleHandle = text(article && article.handle).replace(/^\/+|\/+$/g, '')
    var blogHandle = text(article && article.blog && article.blog.handle)
    if (!articleHandle) return '#'
    if (articleHandle.indexOf('/') !== -1) return '/blogs/' + articleHandle.split('/').map(encodeURIComponent).join('/')

    return blogHandle ? '/blogs/' + encodeURIComponent(blogHandle) + '/' + encodeURIComponent(articleHandle) : '#'
  }

  function sortArticles(articles) {
    return (Array.isArray(articles) ? articles : []).slice().sort(function (left, right) {
      var leftPublishedAt = new Date(left && left.publishedAt || 0).getTime()
      var rightPublishedAt = new Date(right && right.publishedAt || 0).getTime()
      return rightPublishedAt - leftPublishedAt
    })
  }

  function prepareConfiguredArticles(articles) {
    var seen = Object.create(null)
    var uniqueArticles = (Array.isArray(articles) ? articles : []).filter(function (article, index) {
      var blogHandle = text(article && article.blog && article.blog.handle)
      var articleHandle = text(article && article.handle)
      var identifier = text(article && article.id) || (blogHandle && articleHandle ? blogHandle + '/' + articleHandle : '')

      if (!identifier) return true
      if (seen[identifier]) return false
      seen[identifier] = index + 1
      return true
    })

    return sortArticles(uniqueArticles)
  }

  function getFeaturedArticles(selectedArticles, automaticArticles, limit) {
    var selected = Array.isArray(selectedArticles) ? selectedArticles.filter(Boolean) : []
    var automatic = Array.isArray(automaticArticles) ? automaticArticles.filter(Boolean) : []
    var maximum = Math.max(1, Number.parseInt(limit, 10) || 4)

    return (selected.length ? selected : automatic).slice(0, maximum)
  }

  function getFeaturedArticleCopy(article) {
    return {
      category: text(article && article.featuredLabel) || getArticleCategory(article),
      title: text(article && article.featuredTitle) || text(article && article.title),
      description: text(article && article.featuredDescription) || stripHtml(article && article.content),
    }
  }

  function getFeaturedArticleImage(article) {
    var featuredImage = article && article.featuredImage
    return featuredImage && text(featuredImage.url) ? featuredImage : article && article.image
  }

  function isFeaturedVariant(variant) {
    return variant === 'feature-primary' || variant === 'feature-secondary'
  }

  function getActiveFeaturedSlideIndex(offsets, scrollLeft) {
    var positions = Array.isArray(offsets) ? offsets : []
    var position = Math.max(0, Number(scrollLeft) || 0)
    var nearestIndex = 0
    var nearestDistance = Number.POSITIVE_INFINITY

    positions.forEach(function (offset, index) {
      var distance = Math.abs(position - (Number(offset) || 0))
      if (distance < nearestDistance) {
        nearestIndex = index
        nearestDistance = distance
      }
    })

    return nearestIndex
  }

  function createScrollSettler(callback, delay, timerApi) {
    var timers = timerApi || root
    var timeout = Math.max(0, Number(delay) || 0)
    var timerId

    return function (value) {
      if (timerId !== undefined) timers.clearTimeout(timerId)
      timerId = timers.setTimeout(function () {
        timerId = undefined
        callback(value)
      }, timeout)
    }
  }

  function createLiveSearchSettler(callback, delay, timerApi) {
    return createScrollSettler(function (query) {
      callback(text(query))
    }, delay, timerApi)
  }

  function whenDocumentReady(callback, documentRef) {
    var target = documentRef || (typeof document !== 'undefined' ? document : null)
    if (typeof callback !== 'function') return
    if (!target || target.readyState !== 'loading') { callback(); return }

    target.addEventListener('DOMContentLoaded', callback, { once: true })
  }

  function filterArticles(articles, filters) {
    var blogHandle = normalise(filters && filters.blogHandle)
    var query = normalise(filters && filters.query)

    return (Array.isArray(articles) ? articles : []).filter(function (article) {
      var articleCategory = normalise(getArticleCategory(article))
      var articleBlogHandle = normalise(article && article.blog && article.blog.handle)
      if (blogHandle && blogHandle !== 'all' && articleBlogHandle !== blogHandle) return false
      if (!query) return true

      var haystack = [
        article && article.title,
        articleCategory,
        Array.isArray(article && article.tags) ? article.tags.join(' ') : '',
      ].map(stripHtml).join(' ')

      return normalise(haystack).includes(query)
    })
  }

  function paginateArticles(articles, requestedPage, perPage) {
    var items = Array.isArray(articles) ? articles : []
    var pageSize = Math.max(1, Number.parseInt(perPage, 10) || 8)
    var totalPages = Math.max(1, Math.ceil(items.length / pageSize))
    var page = Math.min(Math.max(1, Number.parseInt(requestedPage, 10) || 1), totalPages)
    var offset = (page - 1) * pageSize

    return {
      currentPage: page,
      totalPages: totalPages,
      items: items.slice(offset, offset + pageSize),
    }
  }

  var api = {
    filterArticles: filterArticles,
    createLiveSearchSettler: createLiveSearchSettler,
    createScrollSettler: createScrollSettler,
    getArticleCategory: getArticleCategory,
    getArticleStatuses: getArticleStatuses,
    getArticleUrl: getArticleUrl,
    getActiveFeaturedSlideIndex: getActiveFeaturedSlideIndex,
    getFeaturedArticleCopy: getFeaturedArticleCopy,
    getFeaturedArticleImage: getFeaturedArticleImage,
    getFeaturedArticles: getFeaturedArticles,
    isFeaturedVariant: isFeaturedVariant,
    paginateArticles: paginateArticles,
    prepareConfiguredArticles: prepareConfiguredArticles,
    sortArticles: sortArticles,
    stripHtml: stripHtml,
    whenDocumentReady: whenDocumentReady,
  }

  root.BlogsPage = api

  if (root.document && !root.__blogsEditorListener) {
    root.__blogsEditorListener = true
    root.document.addEventListener('shopify:section:load', function (event) {
      var initializer = event.target.querySelector('script[data-blogs-initializer]')
      if (!initializer) return
      var script = root.document.createElement('script')
      script.textContent = initializer.textContent
      initializer.replaceWith(script)
    })
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api
  }
})(typeof window !== 'undefined' ? window : globalThis)
